// extracted by mini-css-extract-plugin
module.exports = {"accordionItem":"Accordion_accordionItem__qNK_X"};